import { useMutation, useQueryClient } from '@tanstack/react-query';
import { publicCertificationControllerUpdateCertificationTextMutation } from '@dealstack/shared/lib/backendClient/@tanstack/react-query.gen';

/**
 * DC-825: re-stamps the certification document with the certifier's wording. The preview is
 * reset rather than invalidated, so it shows a loader instead of the old stamp while it refetches.
 */
export const useUpdateCertificationText = (token: string) => {
	const queryClient = useQueryClient();
	const mutation = useMutation({
		...publicCertificationControllerUpdateCertificationTextMutation(),
		onSuccess: async () => {
			await Promise.all([
				queryClient.resetQueries({ queryKey: ['public-signing-document', token] }),
				queryClient.invalidateQueries({ queryKey: ['public-signing-info', token] }),
			]);
		},
	});

	return {
		mutate: (text: string, options?: Parameters<typeof mutation.mutate>[1]) =>
			mutation.mutate({ body: { token, text } }, options),
		isPending: mutation.isPending,
		isError: mutation.isError,
	};
};
